import { Instance, types } from 'mobx-state-tree';
import { ParticipantDTO } from 'http-requests/house-chats';
import { RequestStateModel } from '../../general-models';

export const ParticipantModel = types
  .model('ParticipantModel', {
    id: types.string,
    max_user_id: types.number,
    first_name: types.optional(types.maybeNull(types.string), null),
    last_name: types.optional(types.maybeNull(types.string), null),
    username: types.optional(types.maybeNull(types.string), null),
    avatar_url: types.optional(types.maybeNull(types.string), null),
    status: types.optional(types.string, ''),
  })
  .views((self) => ({
    get fullName(): string {
      const name = [self.first_name, self.last_name]
        .filter(Boolean)
        .join(' ')
        .trim();

      return name || self.username || 'Без имени';
    },
  }));

export const ChatParticipantsModel = types
  .model('ChatParticipantsModel', {
    items: types.optional(types.array(ParticipantModel), []),
    requestState: types.optional(RequestStateModel, {}),
  })
  .actions((self) => ({
    setItems(items: ParticipantDTO[]) {
      self.items.replace(
        items
          .filter((item) => item.status !== 'left')
          .map((item) => ({
            id: item.id,
            max_user_id: item.max_user_id,
            first_name: item.first_name,
            last_name: item.last_name,
            username: item.username,
            avatar_url: item.avatar_url,
            status: item.status ?? '',
          })) as unknown as Instance<typeof ParticipantModel>[]
      );
    },
    addParticipant(participant: {
      user_id: number;
      first_name: string | null;
      last_name: string | null;
      avatar_url: string | null;
    }) {
      if (
        self.items.some((item) => item.max_user_id === participant.user_id)
      ) {
        return;
      }

      self.items.push({
        id: String(participant.user_id),
        max_user_id: participant.user_id,
        first_name: participant.first_name,
        last_name: participant.last_name,
        username: null,
        avatar_url: participant.avatar_url,
        status: '',
      } as unknown as Instance<typeof ParticipantModel>);
    },
    removeParticipant(userId: number) {
      const index = self.items.findIndex((item) => item.max_user_id === userId);

      if (index !== -1) {
        self.items.splice(index, 1);
      }
    },
  }));

export type TParticipant = Instance<typeof ParticipantModel>;
export type TChatParticipants = Instance<typeof ChatParticipantsModel>;
